import axiosHttp from "./interceptor.service";

const getEmail = ({ search, sort, limit, page } = {}) => {
    return axiosHttp.get("/feedback/getEmail", {
        params: { search, sort, limit, page },
    });
};

const createEmail = (data) => {
    return axiosHttp.post("/feedback/createEmail", data);
};

const updateEmail = (id, data) => {
    return axiosHttp.put(`/feedback/updateEmail/${id}`, data);
};

const deleteEmail = (id) => {
    return axiosHttp.delete(`/feedback/deleteEmail/${id}`);
};

export { getEmail, createEmail, updateEmail, deleteEmail };
